import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiClient from "../../services/axios";

export const takeCashout = createAsyncThunk(
  'cashout/postCashout',
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiClient.request({
        url: process.env.REACT_APP_CASHOUT_ROUTE,
        method: 'POST',
        data
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const cashoutSlice = createSlice({
  name: "cashout",
  initialState: null,
  reducers: {
    postCashout(state, action) {
      state = action.payload;

      return state;
    },
    clearCashout(state) {
      state = null;

      return state;
    },
    fakeAutoBetCashout(state, action) {
      state = action.payload;

      return state;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(takeCashout.fulfilled, (state, action) => {
        state =  action.payload;
        state.loading = false;

       return state;
      });
  }
});

export const { clearCashout, fakeAutoBetCashout } = cashoutSlice.actions;
export default cashoutSlice.reducer;
